<template>
  <div class="section_wrap">
    <div class="head">
      <!-- <div class="head-left"></div> -->
      <div class="head-center">
        <div class="title">
          <div class="title-text">活动图片</div>
          <div class="title-icon" @click="toMoreData()">
            <el-image class="elimage" :src="moreicon" />
          </div>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="showcase">
        <template>
          <el-row :gutter="20" class="goods-list_left" v-if="leftList.length">
            <el-col v-for="(item, index) in leftList" :key="index" :span="index === 0 ? 24 : 12">
              <div :class="'goods-item left-item' + index">
                <div class="goods-item-img">
                  <template>
                    <div class="goods-img" @click="toDetail(item)">
                      <el-image class="image" :src="item.cover" @error="handleError" />
                    </div>
                  </template>
                </div>
                <div class="goods-item-info">
                  <div class="title multiple">{{ item.title }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="goods-list_right">
            <el-col v-for="(item, index) in rightList" :key="index" :span="index < 2 ? 12 : index == 3 ? 14 : 10">
              <div :class="'goods-item right-item' + index">
                <div class="goods-item-img">
                  <template>
                    <div class="goods-img" @click="toDetail(item)">
                      <el-image class="image" :src="item.cover" @error="handleError" />
                    </div>
                  </template>
                </div>
                <div class="goods-item-info">
                  <div class="title multiple">{{ item.title }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </template>
        <!-- <template v-else>
          <el-empty :image-size="110" class="el-empty--cont"></el-empty>
        </template> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getActivePictureList } from "@/api/activity"
export default {
  name: "homeAlbum",
  components: {},
  data() {
    return {
      queryParams: {
        keyword: "",
        per_page: 7,
        page: 1,
      },
      leftList: [], // 左侧数据
      rightList: [], // 右侧数据
      moreicon: require("@/assets/home/more.png"),
      goodsimage: require("@/assets/default/image02.jpg"),
    }
  },
  computed: {},
  mounted() {
    this.getList()
  },
  methods: {
    handleError(e) {
      e.target.src = this.goodsimage
    },
    // 获取列表数据
    getList() {
      getActivePictureList(this.queryParams).then((res) => {
        if (res.code === 0) {
          this.leftList = []
          this.rightList = []
          res.data?.data?.forEach((item, inx) => {
            if (inx > 2) {
              this.rightList.push(item)
            } else {
              this.leftList.push(item)
            }
          })
        }
      }).catch(() => { })
    },
    // 加载更多数据
    toMoreData() {
      window.localStorage.setItem("menuId", 3)
      this.$store.dispatch("setmenuid", 3)
      this.$router.push({
        path: "/home/album/mainpage",
      })
    },

    toDetail(item) {
      window.localStorage.setItem("menuId", 3)
      this.$store.dispatch("setmenuid", 3)
      this.$router.push({
        path: "/home/album/detail",
        query: {
          id: item.id || "",
        },
      })
    },
  },
};
</script>
<style scoped lang="scss">
.section_wrap {
  width: 100%;

  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 40px;
    margin-bottom: 30px;

    .head-left {
      width: 64px;
    }

    .head-center {

      // flex: 1;
      .title {
        display: flex;
        justify-content: center;
        align-items: center;

        // padding: 0 10px;
        .title-icon {
          width: 32px;
          min-width: 32px;
          height: 32px;
          margin-left: 10px;

          .elimage {
            width: 100%;
            height: 100%;
          }
        }

        .title-text {
          color: #000;
          font-size: 30px;
          font-weight: bold;
          line-height: 40px;
        }
      }
    }

    .head-right {
      .more {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 40px;
        margin-left: 15px;

        .elimage {
          width: 38px;
          height: 38px;
        }
      }
    }
  }

  .body {
    .showcase {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: stretch;

      .goods-item {
        background-color: #fff;
        // box-shadow: 0px 0px 29px 0px rgb(0 80 179 / 8%);
        border-radius: 5px;
        overflow: hidden;
        position: relative;
        cursor: pointer;

        // &:hover {
        //   border: 1px solid rgb(9, 235, 178);
        // }
        .goods-item-img {
          width: 100%;
          height: 100%;
          position: relative;

          .goods-img {
            width: 100%;
            height: 100%;
            background: aliceblue;

            .image {
              display: inline-block;
              -webkit-transition-duration: 0.3s;
              transition-duration: 0.3s;
              -webkit-transition-property: transform;
              transition-property: transform;
              -webkit-transform: translateZ(0);
              transform: translateZ(0);
              box-shadow: 0 0 1px rgba(0, 0, 0, 0);
            }

            .image:hover,
            .image:focus,
            .image:active {
              -webkit-transform: scale(1.1);
              transform: scale(1.1);
            }

            .image {
              width: 100%;
              height: 100%;
            }
          }

          .default-img {
            width: 100%;
            height: 100%;
            // background: #daebfc;
            text-align: center;
            background: aliceblue;

            .image {
              display: inline-block;
              -webkit-transition-duration: 0.3s;
              transition-duration: 0.3s;
              -webkit-transition-property: transform;
              transition-property: transform;
              -webkit-transform: translateZ(0);
              transform: translateZ(0);
              box-shadow: 0 0 1px rgba(0, 0, 0, 0);
            }

            .image:hover,
            .image:focus,
            .image:active {
              -webkit-transform: scale(1.1);
              transform: scale(1.1);
            }

            .image {
              width: 100%;
              height: 100%;
            }
          }
        }

        .goods-item-info {
          width: 100%;
          height: 45px;
          line-height: 45px;
          padding: 0 15px;
          background: rgba(0, 0, 0, 0.5);
          position: absolute;
          left: 0;
          bottom: 0;

          .title {
            color: #fff;
            font-size: 16px;
            font-weight: 400;
          }
        }
      }

      .goods-list_left,
      .goods-list_right {
        width: calc(50% + 10px);
        overflow: hidden;
      }

      .goods-list_left.full-width {
        width: 100%;
      }

      .left-item0 {
        width: 100%;
        height: 472px;
        margin-bottom: 20px;
      }

      .left-item1,
      .left-item2 {
        width: 100%;
        height: 314px;
      }

      .right-item0,
      .right-item1 {
        width: 100%;
        height: 392px;
        margin-bottom: 20px;
      }

      .right-item2,
      .right-item3 {
        width: 100%;
        height: 396px;
      }
    }
  }
}

.el-empty--cont {
  padding: 0px;
  min-height: 200px;
}

@media screen and (max-width: 640px) {
  .section_wrap {
    .head {
      .head-center {
        .title {
          .title-text {
            font-size: 20px;
          }

          .title-icon {
            width: 24px;
            min-width: 24px;
            height: 24px;
          }
        }
      }
    }

    .body {
      .showcase {
        justify-content: space-around;

        .goods-list_left,
        .goods-list_right {
          .goods-item {
            height: 200px;

            .goods-item-info {
              .title {
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }
}
</style>